import { Directive, ElementRef, Host, Optional, Self, TemplateRef } from "@angular/core";
import { RouterLink, RouterLinkWithHref } from "@angular/router";

import { UiTabTemplateContext } from "../models/tab.models";
import { NzTabLinkDirective, NzTabLinkTemplateDirective } from "ng-zorro-antd/tabs";

/**
 * Fix https://github.com/angular/angular/issues/8563
 */
@Directive({
  selector: "ng-template[uiTabLink]",
  exportAs: "uiTabLinkTemplate",
})
export class UiTabLinkTemplateDirective extends NzTabLinkTemplateDirective {
  constructor(@Host() public templateRef: TemplateRef<UiTabTemplateContext>) {
    super(templateRef);
  }
}

/**
 * This component is for catching `routerLink` directive.
 */
@Directive({
  selector: "a[ui-tab-link]",
  exportAs: "uiTabLink",
})
export class UiTabLinkDirective extends NzTabLinkDirective {
  constructor(
    public elementRef: ElementRef<HTMLAnchorElement>,
    @Optional() @Self() public routerLink?: RouterLink,
    @Optional() @Self() public routerLinkWithHref?: RouterLinkWithHref
  ) {
    super(elementRef, routerLink, routerLinkWithHref);
  }
}
